var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "gs1-alert",
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c(
        "i18n",
        { staticClass: "small", attrs: { path: "message", tag: "p" } },
        [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.gs1-germany.de/service/kontakt/",
                target: "_blank",
                rel: "noopener"
              }
            },
            [_vm._v(_vm._s(_vm.$t("contact_gs1")))]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efb85e44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efb85e44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alerts/Gs1AlertNotFound.vue
// module id = null
// module chunks = 